"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodType = void 0;
/**
 * The different kinds of supported payment methods
 */
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["IBAN"] = "IBAN";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
//# sourceMappingURL=PaymentMethodType.js.map